export const loggedIn = state => state.user.token !== null
export const slideMenuItems = state => state.user.slideMenuItems
export const userInfo = state => state.user.info
export const userClients = state => state.user.clients
export const userPermissions = state => state.user.permissions
export const userDefaultMenu = state => state.user.defaultMenu
export const userTimeout = state => state.user.timeout
export const dashboardFilter = state => state.dashboardFilter
export const inventoryLines = state => state.inventory.lines
export const inventoryStatuses = state => state.inventory.statuses
export const productModes = state => state.product.modes
export const documentTypes = state => state.monitoring.types
export const documentSearch = state => state.monitoring.search
export const documentSearchImage = state => state.monitoring.images
export const orderProgressSeach = state => state.orders.search



// WEBPACK FOOTER //
// ./src/vuex/getters.js